import { useMemo } from "react";
import { useQuery, useQueryClient } from "react-query";
import { JobHttpService } from "../service";

const sanitizeFilters = (filters = {}) => {
    return Object.entries(filters)
        .filter(([, value]) => value !== undefined && value !== null && value !== "")
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};

function UseCompanyList({ page = 1, size = 30, filters = {} }) {
    const queryClient = useQueryClient();
    const cleanedFilters = useMemo(() => sanitizeFilters(filters), [filters]);
    const queryKey = ["company_list", page, size, cleanedFilters];

    const { data, isLoading, isFetching, isError, refetch } = useQuery(
        queryKey,
        () => JobHttpService.loadCompanies({ page, size, filters: cleanedFilters }),
        {
            keepPreviousData: true
        }
    );

    const removeItemFromList = (companyId) => {
        queryClient.setQueryData(queryKey, (oldData) => {
            if (!oldData || !oldData.results) return oldData;
            return {
                ...oldData,
                results: oldData.results.filter((company) => company.id !== companyId)
            };
        });
    };

    return { data, isLoading, isFetching, isError, refetch, removeItemFromList };
}

export default UseCompanyList;